import {Component, EventEmitter, OnInit} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {ModalComponent} from '../../common/component/modal/modal-service.service';
import {NgClass} from '@angular/common';
import {NlrPatternDirective} from '../../common/directive/nlr-pattern.directive';
import {NlrFormFieldHasErrorPipe} from '../../common/pipe/nlr-form-field-has-error.pipe';
import {PlanModelService} from '../../common/service/plan-model.service';
import {PlanPdfService} from '../../common/service/plan-pdf.service';
import {DigitalPlanService} from '../digital-plan.service';
import {NgEventBus} from 'ng-event-bus';
import {NgSelectModule} from '@ng-select/ng-select';
import {FirmSettingsService} from '../../common/service/firm-settings.service';

@Component({
    selector: 'nlr-digital-plan-print-modal',
    standalone: true,
    imports: [FormsModule, NgClass, NlrPatternDirective, NlrFormFieldHasErrorPipe, NgSelectModule],
    templateUrl: './digital-plan-print-modal.component.html',
    styleUrls: ['../../common/component/modal/modal.scss', './digital-plan-print-modal.component.scss']
})
export class DigitalPlanPrintModalComponent implements ModalComponent, OnInit {
    title = 'Print Plan Pdf';

    modalClosed: EventEmitter<string> = new EventEmitter();

    modalSize: string = 'modal-md';

    watermarkRegex = /^[- a-zA-Z0-9\\*/\n]+$/;

    watermarkText = '';

    errorText = '';

    constructor(
        private eventBus: NgEventBus,
        private planModelService: PlanModelService,
        private planPdfService: PlanPdfService,
        private digitalPlanService: DigitalPlanService,
        private firmSettingsService: FirmSettingsService
    ) {}

    ngOnInit() {
        if (this.showWatermark()) {
            const subscription = this.firmSettingsService.getDefaultPdfWatermark().subscribe({
                next: defaultPdfWatermark => (this.watermarkText = defaultPdfWatermark || ''),
                error: reason => console.error(this.title, 'ngOnInit - firmSettingsService#getDefaultPdfWatermark error: ', reason)
            });

            this.eventBus.cast('nlr:busy', subscription);
        }
    }

    getMaxWatermarkCharacters() {
        const newLineCount = this.watermarkText.split('\n').length - 1;
        return 70 + newLineCount;
    }

    getWatermarkCharactersRemaining() {
        return this.getMaxWatermarkCharacters() - this.watermarkText.length;
    }

    showWatermark() {
        return this.planPdfService.showWatermark(this.planModelService.getModel());
    }

    onChangeWatermarkText(watermarkText: string) {
        this.watermarkText = watermarkText;
        this.errorText = '';
    }

    print() {
        const logPrefix = `${this.title} - print`;
        console.debug(logPrefix);

        this.errorText = '';

        const subscription = this.digitalPlanService.printAndDisplay(this.watermarkText).subscribe({
            next: () => this.closeDialog(),
            error: error => {
                console.error(`${logPrefix} - error:`, error);
                this.errorText = 'Error printing plan';
            }
        });

        this.eventBus.cast('nlr:busy', subscription);
    }

    closeDialog() {
        this.modalClosed.emit('Close dialog');
    }
}
